import React from "react";

import Styles from "./ArrowAnchorButton.styles";
import { ArrowAnchorButtonProps as Props } from "./ArrowAnchorButton.types";

import ChevronRightSVG from "../../../../public/assets/images/arrow-right-black.svg";

const ArrowAnchorButton: React.FC<Props> = props => {
  const { buttonText, uri } = props;

  return (
    <Styles className="ArrowAnchorButton">
      <a
        href={uri}
        target="_blank"
        rel="noopener noreferrer"
        className="ArrowAnchorButton__anchor"
      >
        <div className="ArrowAnchorButton__link">
          {buttonText}
          <ChevronRightSVG />
        </div>
      </a>
    </Styles>
  );
};

ArrowAnchorButton.defaultProps = {};

export default ArrowAnchorButton;
